import React from 'react';
import { featureKeys } from 'services/FeatureFlagService';

import NavBrand from './NavBrand';
import NavBackButton from './NavBackButton';

import {
  NavHeader,
  NavWrapper,
} from './styles';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';

const NavHead = ({ backTo, mobileSidebarOpen, getFeatureFlagValue }) =>(
  <NavWrapper
    newUX={getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22)}
    mobileSidebarOpen={mobileSidebarOpen}>
    <NavHeader style={{ overflow: 'visible' }}>
      {backTo && <NavBackButton backTo={backTo} />}
      <NavBrand />
    </NavHeader>
  </NavWrapper>
);

const flagNames = [featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22];
export default enhanceWithFeatureFlagSubscription(NavHead, flagNames);